import * as React from 'react';

var _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgCurrencyExchangeSolid = function SvgCurrencyExchangeSolid(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor",
        viewBox: "0 0 24 24"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        d: "M12.89 11.1c-1.78-.59-2.64-.96-2.64-1.9 0-1.02 1.11-1.39 1.81-1.39.665 0 1.117.256 1.414.553.354.354.885.618 1.345.423.407-.173.615-.634.382-1.01-.307-.493-.83-1.08-1.658-1.387-.306-.113-.543-.386-.543-.712A.677.677 0 0 0 12.323 5H11.7a.7.7 0 0 0-.7.7c0 .328-.231.604-.537.721C8.52 7.166 8.51 9.128 8.51 9.22c0 2.27 2.25 2.91 3.35 3.31 1.58.56 2.28 1.07 2.28 2.03 0 1.13-1.05 1.61-1.98 1.61-1.044 0-1.66-.615-2.007-1.181-.276-.451-.824-.735-1.314-.537-.42.17-.653.634-.46 1.043a4 4 0 0 0 2.1 2.03c.302.129.521.41.521.738 0 .407.33.737.737.737h.574c.38 0 .689-.308.689-.689 0-.322.226-.593.532-.692.861-.28 2.368-1.037 2.368-3.079 0-1.39-.61-2.61-3.01-3.44M3 20a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H4.52c1.61 2.41 4.36 4 7.48 4 4.633 0 8.448-3.501 8.945-8.002.06-.549.503-.998 1.055-.998s1.005.45.955 1C22.451 18.61 17.743 23 12 23c-3.72 0-7.01-1.85-9-4.67zm-1-8c-.552 0-1.005-.45-.955-1C1.549 5.39 6.257 1 12 1c3.72 0 7.01 1.85 9 4.67V4a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h1.48C17.87 4.59 15.12 3 12 3c-4.633 0-8.448 3.501-8.945 8.002C2.995 11.55 2.552 12 2 12"
    })));
};

export { SvgCurrencyExchangeSolid as ReactComponent };
//# sourceMappingURL=CurrencyExchangeSolid.svg.es.js.map
